export const aboutData = {
  title: "Güçlü Geçmiş, Sağlam Gelecek",
  description:
    "Hangar Mühendislik San.Tic.A.Ş., 2009 yılından bu yana Ankara merkezli olarak endüstriyel yapı sektöründe faaliyet gösteren bir mühendislik ve inşaat firmasıdır. Çelik konstrüksiyon, fabrika ve depo yapıları ile anahtar teslim projelerde müşterilerimize güvenilir çözümler sunuyoruz.",
  description2:
    "Modern üretim tesisimiz, deneyimli mühendislik ekibimiz ve sahada uzman montaj kadromuzla, her projeyi zamanında, bütçe dahilinde ve en yüksek kalite standartlarıyla teslim etmeyi ilke edindik.",
  sinceYear: "2009",
  image:
    "https://storage.readdy-site.link/project_files/ca0597d3-e4ee-4889-8ae5-f7591fdfc85d/58ab5f28-3592-40c8-b5e9-8eb9636f3001_img-2.jpeg?v=1086701f389696e02e2d9a68d4339d33",
  values: [
    {
      icon: "ri-shield-star-line",
      title: "Güvenilirlik",
      description: "Söz verdiğimiz her taahhüdü yerine getiriyoruz",
    },
    {
      icon: "ri-medal-line",
      title: "Kalite",
      description: "ISO standartlarında üretim ve montaj süreçleri",
    },
    {
      icon: "ri-lightbulb-line",
      title: "İnovasyon",
      description: "Mühendislikte modern teknolojileri aktif kullanıyoruz",
    },
  ],
};

export const features = [
  {
    icon: "ri-settings-4-line",
    title: "Mühendislik",
    description: "Statik hesaplama, uygulama projeleri ve sahaya uygun üretim planlama",
  },
  {
    icon: "ri-shield-check-line",
    title: "Kalite",
    description: "ISO standartlarına uygun üretim ve montaj süreçleri",
  },
  {
    icon: "ri-time-line",
    title: "Güvenilir",
    description: "Söz verdiğimiz tarihte teslimat, şeffaf proje yönetimi",
  },
  {
    icon: "ri-key-2-line",
    title: "Anahtar Teslim",
    description: "Projeden teslimata kadar tek elden hizmet sunuyoruz",
  },
];

export const services = [
  {
    id: 1,
    slug: "hangar-yapilari",
    title: "Hangar Yapıları",
    description: "Uçak, helikopter ve büyük ekipman barındırma için dayanıklı çelik hangar yapıları projelendirme, imalat ve montaj hizmetleri.",
    fullDescription:
      "Hangar Mühendislik olarak, askeri ve sivil havacılık sektörünün ihtiyaç duyduğu büyük açıklıklı çelik hangar yapılarını tasarımdan montaja kadar kapsamlı bir şekilde gerçekleştiriyoruz. Uçak bakım, onarım ve depolama alanları için optimize edilmiş, yüksek açıklıklı ve sütunsuz iç mekanlar sunuyoruz. Hangar kapı sistemleri, iklimlendirme, havalandırma ve yangın güvenliği entegrasyonu ile tam donanımlı çözümler üretiyoruz. NATO standartlarına uygun, deprem yönetmeliğine göre hesaplanmış ve güvenilir yapı sistemleri ile havacılık sektörüne değer katıyoruz.",
    image: "https://storage.readdy-site.link/project_files/ca0597d3-e4ee-4889-8ae5-f7591fdfc85d/724daf6f-0090-4f57-8241-9e36c32b7fb4_img-16.jpeg?v=7546678b1a592be0cd9b9950123b9426",
    gallery: [
      "https://storage.readdy-site.link/project_files/ca0597d3-e4ee-4889-8ae5-f7591fdfc85d/724daf6f-0090-4f57-8241-9e36c32b7fb4_img-16.jpeg?v=7546678b1a592be0cd9b9950123b9426",
      "https://storage.readdy-site.link/project_files/ca0597d3-e4ee-4889-8ae5-f7591fdfc85d/2c114a15-9b16-4d21-94f5-9533987392d8_img-6.jpeg?v=e67ffcff377d2fc8f314efec02767fd7",
      "https://storage.readdy-site.link/project_files/ca0597d3-e4ee-4889-8ae5-f7591fdfc85d/58ab5f28-3592-40c8-b5e9-8eb9636f3001_img-2.jpeg?v=1086701f389696e02e2d9a68d4339d33",
    ],
    featuresList: [
      "30m+ açıklık imkanı (sütunsuz iç mekan)",
      "NATO ve sivil havacılık standartlarına uygun tasarım",
      "Hangar kapısı entegrasyonu (katlanır / kayar)",
      "Yangın algılama ve söndürme sistemi entegrasyonu",
      "Deprem yönetmeliğine uygun statik hesaplama",
      "Havalandırma, iklimlendirme ve aydınlatma çözümleri",
    ],
    technologies: [
      "3D SAP2000 / ETABS statik modelleme",
      "Tekla Structures detay çelik projelendirme",
      "CNC kontrollü sac kesim ve büküm",
      "TSE belgeli galvaniz kaplama",
      "Yangına dayanıklı boya sistemleri",
    ],
  },
  {
    id: 2,
    slug: "fabrika-yapilari",
    title: "Fabrika Yapıları",
    description: "Endüstriyel üretim tesisleri, montaj hatları ve özel ihtiyaçlara yönelik fabrika yapıları için kapsamlı çelik konstrüksiyon çözümleri.",
    fullDescription:
      "Endüstriyel üretim tesisleri, montaj hatları ve tekstil, gıda, otomotiv gibi sektörlere özel fabrika yapıları için çelik konstrüksiyon çözümler üretiyoruz. Çatı yüksekliği, kolon aralıkları, vinç kirişi kapasiteleri ve zemin yükleri gibi parametreleri müşterinin üretim akışına göre optimize ediyoruz. Sandviç panel çatı ve cephe sistemleri, doğal aydınlatma hatları ve enerji verimli yalıtım çözümleri ile modern fabrika yapıları inşa ediyoruz. Anahtar teslim projelerde elektrik, mekanik tesisat ve zemin kaplaması gibi tüm yan işlerin koordinasyonunu da üstleniyoruz.",
    image: "https://storage.readdy-site.link/project_files/ca0597d3-e4ee-4889-8ae5-f7591fdfc85d/73483001-ccf5-41a6-8462-acf55ddc0f1c_img-17.jpeg?v=60629cfc282d1be4a8f9143459ddb96b",
    gallery: [
      "https://storage.readdy-site.link/project_files/ca0597d3-e4ee-4889-8ae5-f7591fdfc85d/73483001-ccf5-41a6-8462-acf55ddc0f1c_img-17.jpeg?v=60629cfc282d1be4a8f9143459ddb96b",
      "https://storage.readdy-site.link/project_files/ca0597d3-e4ee-4889-8ae5-f7591fdfc85d/e0aeef61-d150-4a1a-abc0-4a5415da7013_img-7.jpeg?v=dc4538817952dfc3019023a615b78a69",
      "https://storage.readdy-site.link/project_files/ca0597d3-e4ee-4889-8ae5-f7591fdfc85d/0b10cde4-79b3-4834-8025-f6c37e12124b_img4.jpeg?v=001a87ce4f8b1a4e7814662587e1c32d",
    ],
    featuresList: [
      "10t - 50t vinç kirişi kapasiteli sistemler",
      "Esnek kolon aralıkları üretim hatlarına göre düzenlenebilir",
      "Sandviç panel çatı ve cephe yalıtım çözümleri",
      "Doğal aydınlatma hatları (skylight) entegrasyonu",
      "Yangın yalıtımlı çelik elemanlar (intumescent boya)",
      "Anahtar teslim proje yönetimi ve koordinasyon",
    ],
    technologies: [
      "Revit & Tekla 3D BIM modelleme",
      "SAP2000 / STAAD.Pro statik analiz",
      "Sandviç panel sistemleri (PIR / Taşyünü)",
      "CNC plazma / oksijen sac kesim",
      "Yangın yalıtımlı boya (intumescent coating)",
    ],
  },
  {
    id: 3,
    slug: "depo-antrepo",
    title: "Depo & Antrepo",
    description: "Lojistik merkezleri, soğuk hava depoları ve yüksek kapasiteli antrepolar için optimize edilmiş depolama yapıları.",
    fullDescription:
      "Lojistik sektörünün ihtiyaç duyduğu yüksek kapasiteli depo ve antrepo yapılarını en verimli şekilde tasarlıyor ve inşa ediyoruz. Raf sistemleri entegrasyonu, geniş araç manevra alanları, yüksek açıklıklı ve sütunsuz iç mekanlar ile depolama verimliliğini maksimize ediyoruz. Soğuk hava depolarında PIR sandviç panel sistemleri, enerji verimli soğutma entegrasyonu ve hijyenik zemin çözümleri sunuyoruz. Dış cephede yüksek dayanımlı çelik konstrüksiyon ve modern kapı / rampa sistemleri ile lojistik akışını optimize ediyoruz. Tüm projelerimizde yangın güvenliği, acil tahliye ve deprem yönetmeliği standartlarına eksiksiz uyum sağlıyoruz.",
    image: "https://storage.readdy-site.link/project_files/ca0597d3-e4ee-4889-8ae5-f7591fdfc85d/6fba704c-d2b8-4623-a5be-f85e4e036a85_img-18.jpeg?v=c75405b7cf70cf6e1aee80c9178c1ea0",
    gallery: [
      "https://storage.readdy-site.link/project_files/ca0597d3-e4ee-4889-8ae5-f7591fdfc85d/6fba704c-d2b8-4623-a5be-f85e4e036a85_img-18.jpeg?v=c75405b7cf70cf6e1aee80c9178c1ea0",
      "https://storage.readdy-site.link/project_files/ca0597d3-e4ee-4889-8ae5-f7591fdfc85d/e202406c-d174-481b-a804-7468d0612147_img-9.jpeg?v=27c1d2df5c102f859c99de13dfce6c29",
      "https://storage.readdy-site.link/project_files/ca0597d3-e4ee-4889-8ae5-f7591fdfc85d/0b10cde4-79b3-4834-8025-f6c37e12124b_img4.jpeg?v=001a87ce4f8b1a4e7814662587e1c32d",
    ],
    featuresList: [
      "12m+ tavan yüksekliği (yüksek raflama imkanı)",
      "Sütunsuz iç mekanlar (geniş araç manevra alanı)",
      "Raf sistemleri entegrasyonu (lojistik verimlilik)",
      "Soğuk hava depolarında PIR sandviç panel çözümleri",
      "Yük rampaları ve sevkiyat kapısı entegrasyonu",
      "Yangın algılama, sprinkler ve acil tahliye sistemleri",
    ],
    technologies: [
      "Depo verimlilik analizi ve optimizasyon",
      "PIR / EPS soğuk hava izolasyon panelleri",
      "CNC hassas kesim ve montaj kalıpları",
      "Yüksek dayanımlı galvaniz çelik profiller",
      "Raf sistemi entegrasyonlu statik hesaplama",
    ],
  },
  {
    id: 4,
    slug: "celik-konstruksiyon",
    title: "Çelik Konstrüksiyon",
    description: "Köprü, platform, kafes kiriş sistemleri ve özel çelik yapı elemanlarının dizaynı, imalatı ve montajı.",
    fullDescription:
      "Köprü, platform, merdiven kuleleri, kafes kiriş sistemleri, çelik çatı truss'ları ve özel amaçlı çelik yapı elemanlarının tasarımından montajına kadar tüm süreçleri yönetiyoruz. Ağır sanayi, enerji, maden ve petrokimya sektörlerine özel çelik yapılar üretiyoruz. Çelik merdiven, platform, korkuluk ve iskele sistemlerinin yanı sıra, mevcut yapılara ekleme yapılan çelik güçlendirme projeleri de gerçekleştiriyoruz. Tüm çelik elemanlarımız TSE belgeli galvaniz kaplama veya koruyucu boya ile uzun ömürlü hale getiriliyor. Kaynak işlemlerinde MIG, MAG ve TIG yöntemleri kullanılarak uluslararası kaynak standartlarına uygun üretim yapılıyor.",
    image: "https://storage.readdy-site.link/project_files/ca0597d3-e4ee-4889-8ae5-f7591fdfc85d/58ab5f28-3592-40c8-b5e9-8eb9636f3001_img-2.jpeg?v=1086701f389696e02e2d9a68d4339d33",
    gallery: [
      "https://storage.readdy-site.link/project_files/ca0597d3-e4ee-4889-8ae5-f7591fdfc85d/58ab5f28-3592-40c8-b5e9-8eb9636f3001_img-2.jpeg?v=1086701f389696e02e2d9a68d4339d33",
      "https://storage.readdy-site.link/project_files/ca0597d3-e4ee-4889-8ae5-f7591fdfc85d/4cd7994c-3362-45fb-b59a-e59524ed7708_img-3.jpeg?v=d9acff705403eef0f989036c6c21b62c",
      "https://storage.readdy-site.link/project_files/ca0597d3-e4ee-4889-8ae5-f7591fdfc85d/58ab5f28-3592-40c8-b5e9-8eb9636f3001_img-2.jpeg?v=1086701f389696e02e2d9a68d4339d33",
    ],
    featuresList: [
      "Köprü, platform ve kafes kiriş sistemleri",
      "Çelik merdiven, korkuluk ve iskele yapıları",
      "Mevcut yapılara çelik ekleme ve güçlendirme",
      "Truss ve çatı taşıyıcı sistemleri",
      "Ağır sanayi ve enerji sektörü özel yapıları",
      "Uluslararası kaynak standartlarına uygun üretim",
    ],
    technologies: [
      "Tekla Structures detaylı çelik modelleme",
      "SAP2000 / Midas kiriş ve kafes analizi",
      "MIG, MAG, TIG kaynak teknolojileri",
      "CNC boru profil kesim ve delme",
      "TSE belgeli galvaniz kaplama hatları",
    ],
  },
  {
    id: 5,
    slug: "proje-muhendislik",
    title: "Proje & Mühendislik",
    description: "Statik hesaplama, 3D modelleme, yapısal analiz ve tüm proje yönetimi hizmetleriyle mühendislik danışmanlığı.",
    fullDescription:
      "Mühendislik danışmanlığı hizmetlerimiz kapsamında, yapısal statik hesaplama, 3D BIM modelleme, uygulama projesi hazırlama ve proje yönetimi hizmetleri sunuyoruz. SAP2000, ETABS ve STAAD.Pro gibi endüstri standardı yazılımlarla deprem yükleri, rüzgar yükleri, kar yükü ve hareketli yük kombinasyonları altında yapısal güvenlik analizleri yapıyoruz. Tekla Structures ile detaylı çelik montaj projeleri hazırlıyor, üretim listeleri (BOM), montaj çizimleri ve CNC girdi dosyalarını otomatik olarak üretiyoruz. Ayrıca mevcut yapıların güçlendirme projeleri, tadilat ve genişletme projelerinde de mühendislik desteği veriyoruz. Proje süreçlerinde Gantt şemaları ile ilerleme takibi, maliyet kontrolü ve kalite yönetimi uyguluyoruz.",
    image: "https://storage.readdy-site.link/project_files/ca0597d3-e4ee-4889-8ae5-f7591fdfc85d/4cd7994c-3362-45fb-b59a-e59524ed7708_img-3.jpeg?v=d9acff705403eef0f989036c6c21b62c",
    gallery: [
      "https://storage.readdy-site.link/project_files/ca0597d3-e4ee-4889-8ae5-f7591fdfc85d/4cd7994c-3362-45fb-b59a-e59524ed7708_img-3.jpeg?v=d9acff705403eef0f989036c6c21b62c",
      "https://storage.readdy-site.link/project_files/ca0597d3-e4ee-4889-8ae5-f7591fdfc85d/58ab5f28-3592-40c8-b5e9-8eb9636f3001_img-2.jpeg?v=1086701f389696e02e2d9a68d4339d33",
      "https://storage.readdy-site.link/project_files/ca0597d3-e4ee-4889-8ae5-f7591fdfc85d/e202406c-d174-481b-a804-7468d0612147_img-9.jpeg?v=27c1d2df5c102f859c99de13dfce6c29",
    ],
    featuresList: [
      "Deprem, rüzgar, kar ve hareketli yük analizleri",
      "3D BIM modelleme ve çakışma kontrolü (clash detection)",
      "Detaylı çelik montaj projesi ve üretim listesi (BOM)",
      "Mevcut yapıların güçlendirme ve tadilat projeleri",
      "Proje yönetimi ve ilerleme takibi (Gantt)",
      "Maliyet kontrolü ve kalite yönetimi süreçleri",
    ],
    technologies: [
      "SAP2000 / ETABS / STAAD.Pro statik analiz",
      "Tekla Structures BIM ve detay projelendirme",
      "Revit mimari / yapısal koordinasyon",
      "AutoCAD & Advance Steel detay çizim",
      "Microsoft Project / Primavera proje yönetimi",
    ],
  },
];

export const projects = [
  {
    id: 1,
    name: "Alyon Mühendislik",
    location: "Esenyurt, İstanbul",
    year: "2024",
    reference: "Depo Yapısı",
    image: "https://storage.readdy-site.link/project_files/ca0597d3-e4ee-4889-8ae5-f7591fdfc85d/0b10cde4-79b3-4834-8025-f6c37e12124b_img4.jpeg?v=001a87ce4f8b1a4e7814662587e1c32d",
  },
  {
    id: 2,
    name: "Ezgü Geri Dönüşüm",
    location: "Kahramankazan, Ankara",
    year: "2023",
    reference: "Üretim Tesisi",
    image: "https://storage.readdy-site.link/project_files/ca0597d3-e4ee-4889-8ae5-f7591fdfc85d/43de59a8-5bdd-44ba-b56a-74965774a3bd_img-5.jpeg?v=a0969684aa9ee2af13d519f340ab4f28",
  },
  {
    id: 3,
    name: "Orkun Yapı",
    location: "Etimesgut, Ankara",
    year: "2023",
    reference: "Hangar Yapısı",
    image: "https://storage.readdy-site.link/project_files/ca0597d3-e4ee-4889-8ae5-f7591fdfc85d/2c114a15-9b16-4d21-94f5-9533987392d8_img-6.jpeg?v=e67ffcff377d2fc8f314efec02767fd7",
  },
  {
    id: 4,
    name: "Hortum Marketler",
    location: "Gebze, Kocaeli",
    year: "2022",
    reference: "Fabrika Yapısı",
    image: "https://storage.readdy-site.link/project_files/ca0597d3-e4ee-4889-8ae5-f7591fdfc85d/e0aeef61-d150-4a1a-abc0-4a5415da7013_img-7.jpeg?v=dc4538817952dfc3019023a615b78a69",
  },
  {
    id: 5,
    name: "Teksan Hidrolik",
    location: "Antalya",
    year: "2022",
    reference: "Soğuk Hava Deposu",
    image: "https://storage.readdy-site.link/project_files/ca0597d3-e4ee-4889-8ae5-f7591fdfc85d/e202406c-d174-481b-a804-7468d0612147_img-9.jpeg?v=27c1d2df5c102f859c99de13dfce6c29",
  },
];

export const processSteps = [
  {
    step: 1,
    icon: "ri-search-line",
    title: "İhtiyaç Analizi",
    description: "Proje gereksinimlerinizi detaylı analiz ederek en uygun çözümü belirliyoruz.",
  },
  {
    step: 2,
    icon: "ri-pencil-ruler-2-line",
    title: "Tasarım & Proje",
    description: "Statik hesaplama, 3D modelleme ve uygulama projeleri hazırlıyoruz.",
  },
  {
    step: 3,
    icon: "ri-hammer-line",
    title: "İmalat",
    description: "ISO kalite standartlarında modern tesislerimizde üretim yapıyoruz.",
  },
  {
    step: 4,
    icon: "ri-building-line",
    title: "Montaj",
    description: "Deneyimli ekibimizle sahada profesyonel montaj gerçekleştiriyoruz.",
  },
  {
    step: 5,
    icon: "ri-checkbox-circle-line",
    title: "Teslim",
    description: "Kalite kontrol süreçlerinden geçirerek projeyi zamanında teslim ediyoruz.",
  },
];

export const stats = [
  { value: 250, suffix: "+", label: "Tamamlanan Proje" },
  { value: 150, suffix: "+", label: "Mutlu Müşteri" },
  { value: 20, suffix: "+", label: "Uzman Ekip" },
  { value: 15, suffix: "+", label: "Yıllık Deneyim" },
];

export const testimonials = [
  {
    id: 1,
    company: "ASF Lojistik",
    logo: "https://storage.readdy-site.link/project_files/ca0597d3-e4ee-4889-8ae5-f7591fdfc85d/adf6523f-acdd-49d5-a202-3af688af613e_img-13.jpeg?v=339ff2b02e9e3c1dddc7665ed16f3f57",
    comment: "Hangar Mühendislik, depo projemizde gösterdikleri profesyonellik ve zamanında teslimat ile beklentilerimizin üzerine çıktılar. Çelik konstrüksiyon kalitesi mükemmel.",
    author: "Mehmet Kaya",
    role: "Tesis Müdürü",
  },
  {
    id: 2,
    company: "NETAŞ",
    logo: "https://storage.readdy-site.link/project_files/ca0597d3-e4ee-4889-8ae5-f7591fdfc85d/b16ca462-ae31-448f-877a-cad89d28b08b_img-14.jpeg?v=4a7e2d8935cc3c18fabb370291624397",
    comment: "Üretim tesisimizin genişletme projesinde Hangar Mühendislik ile çalışmaktan büyük memnuniyet duyduk. Mühendislik ekibinin uzmanlığı ve sahada pratik çözümleri takdire şayan.",
    author: "Ayşe Yılmaz",
    role: "Proje Direktörü",
  },
  {
    id: 3,
    company: "Otomotiv A.Ş.",
    logo: "https://storage.readdy-site.link/project_files/ca0597d3-e4ee-4889-8ae5-f7591fdfc85d/ea8c0e47-2d0e-4d52-a65d-56c23d93657a_img-15.jpeg?v=2ca46a084d3baabb1d9e56d4a6fca622",
    comment: "Fabrika yapımızın çelik konstrüksiyon işlerini Hangar Mühendislik üstlendi. Güvenilir firma, kaliteli işçilik ve şeffaf iletişim süreci ile ön planda.",
    author: "Ali Demir",
    role: "Genel Müdür",
  },
];

export const blogPosts = [
  {
    id: 1,
    title: "2024 Yılı Çelik Konstrüksiyon Trendleri",
    date: "15 Mart 2024",
    category: "Çelik Konstrüksiyon",
    image: "https://storage.readdy-site.link/project_files/ca0597d3-e4ee-4889-8ae5-f7591fdfc85d/5e9154ac-a13c-4eba-9ced-bca9c2312323_img-10.jpeg?v=8a3f7d4400da1472d6d58694865bcb9a",
    excerpt: "Endüstriyel yapılarda çelik konstrüksiyonun geleceği, yeni malzemeler ve sürdürülebilir üretim teknikleri hakkında detaylı bir inceleme.",
  },
  {
    id: 2,
    title: "Fabrika Yapılarında Yangın Güvenliği",
    date: "28 Şubat 2024",
    category: "Fabrika",
    image: "https://storage.readdy-site.link/project_files/ca0597d3-e4ee-4889-8ae5-f7591fdfc85d/6c606fa1-ab32-4df7-a5f9-570cfd8e38fb_img-11.jpeg?v=6a5a8878e75977536838ae9ef486512c",
    excerpt: "Endüstriyel tesislerde yangın güvenliği standartları, koruyucu boya sistemleri ve yangın yalıtımlı çelik yapı elemanları.",
  },
  {
    id: 3,
    title: "Depo Tasarımında Verimlilik Prensipleri",
    date: "10 Ocak 2024",
    category: "Depo",
    image: "https://storage.readdy-site.link/project_files/ca0597d3-e4ee-4889-8ae5-f7591fdfc85d/80ff3e5d-8d19-4c4c-8636-7d3f663e79b2_img-12.jpeg?v=bda384c79d9f775742b40838c87d8343",
    excerpt: "Lojistik merkezlerinde verimli depo tasarımı, kolon aralıkları, yükseklik optimizasyonu ve raf sistemleri entegrasyonu.",
  },
  {
    id: 4,
    title: "Çelik Yapıların Deprem Performansı ve Güçlendirme",
    date: "20 Aralık 2023",
    category: "Çelik Konstrüksiyon",
    image: "https://storage.readdy-site.link/project_files/ca0597d3-e4ee-4889-8ae5-f7591fdfc85d/58ab5f28-3592-40c8-b5e9-8eb9636f3001_img-2.jpeg?v=1086701f389696e02e2d9a68d4339d33",
    excerpt: "Deprem bölgelerinde çelik konstrüksiyon yapıların davranışı, performans analizleri ve mevcut yapıların güçlendirme yöntemleri.",
  },
  {
    id: 5,
    title: "Hangar Yapılarında İklimlendirme ve Havalandırma",
    date: "5 Kasım 2023",
    category: "Hangar",
    image: "https://storage.readdy-site.link/project_files/ca0597d3-e4ee-4889-8ae5-f7591fdfc85d/724daf6f-0090-4f57-8241-9e36c32b7fb4_img-16.jpeg?v=7546678b1a592be0cd9b9950123b9426",
    excerpt: "Büyük açıklıklı hangar yapılarında enerji verimli iklimlendirme, doğal havalandırma sistemleri ve nem kontrolü çözümleri.",
  },
  {
    id: 6,
    title: "Endüstriyel Çatı Sistemleri ve Yalıtım Teknolojileri",
    date: "10 Eylül 2023",
    category: "Fabrika",
    image: "https://storage.readdy-site.link/project_files/ca0597d3-e4ee-4889-8ae5-f7591fdfc85d/73483001-ccf5-41a6-8462-acf55ddc0f1c_img-17.jpeg?v=60629cfc282d1be4a8f9143459ddb96b",
    excerpt: "Fabrika ve depo yapılarında sandviç panel çatılar, ısı yalıtımı, su yalıtımı ve uzun ömürlü çatı kaplama sistemleri.",
  },
  {
    id: 7,
    title: "Çelik Konstrüksiyonda Kaynak Teknikleri ve Kalite Kontrol",
    date: "15 Ağustos 2023",
    category: "Çelik Konstrüksiyon",
    image: "https://storage.readdy-site.link/project_files/ca0597d3-e4ee-4889-8ae5-f7591fdfc85d/4cd7994c-3362-45fb-b59a-e59524ed7708_img-3.jpeg?v=d9acff705403eef0f989036c6c21b62c",
    excerpt: "Endüstriyel çelik yapı üretiminde MIG, MAG ve TIG kaynak yöntemleri, kaynak kalite kontrolü ve ultrasonik test prosedürleri.",
  },
  {
    id: 8,
    title: "Soğuk Hava Depolarında İzolasyon ve Enerji Verimliliği",
    date: "22 Haziran 2023",
    category: "Depo",
    image: "https://storage.readdy-site.link/project_files/ca0597d3-e4ee-4889-8ae5-f7591fdfc85d/e202406c-d174-481b-a804-7468d0612147_img-9.jpeg?v=27c1d2df5c102f859c99de13dfce6c29",
    excerpt: "Soğuk zincir lojistiğinde depo izolasyon standartları, PIR panel sistemleri ve enerji tasarruflu soğutma çözümleri.",
  },
  {
    id: 9,
    title: "Fabrika Yapılarında Acil Durum ve Tahliye Planlaması",
    date: "30 Nisan 2023",
    category: "Fabrika",
    image: "https://storage.readdy-site.link/project_files/ca0597d3-e4ee-4889-8ae5-f7591fdfc85d/e0aeef61-d150-4a1a-abc0-4a5415da7013_img-7.jpeg?v=dc4538817952dfc3019023a615b78a69",
    excerpt: "Endüstriyel tesislerde yangın tahliye yolları, acil çıkış kapıları, duman tahliyesi ve iş güvenliği mevzuatına uygun planlama.",
  },
];

export const navLinks = [
  { label: "Anasayfa", href: "/" },
  { label: "Hizmetler", href: "/hizmetler" },
  { label: "Projeler", href: "/projeler" },
  { label: "Hakkımızda", href: "/hakkimizda" },
  { label: "Blog", href: "/blog" },
  { label: "İletişim", href: "/iletisim" },
];

export const footerLinks = [
  { label: "Anasayfa", href: "/" },
  { label: "Hizmetler", href: "/hizmetler" },
  { label: "Projeler", href: "/projeler" },
  { label: "Hakkımızda", href: "/hakkimizda" },
  { label: "Blog", href: "/blog" },
  { label: "İletişim", href: "/iletisim" },
];

export const contactInfo = {
  phone: "0543 781 18 43",
  phoneSecondary: "0541 828 33 94",
  whatsapp: "905418283394",
  email: "info@hangarmuhendislik.com",
  address: "Saray Mah. 618. Cad. No:13/B Kahramankazan / Ankara",
  workingHours: "Pzt - Cmt: 08:00 - 18:00",
};
